import { render, staticRenderFns } from "./loading-spinner.vue?vue&type=template&id=ba4d8b6c&scoped=true&"
import script from "./loading-spinner.vue?vue&type=script&lang=js&"
export * from "./loading-spinner.vue?vue&type=script&lang=js&"
import style0 from "./loading-spinner.vue?vue&type=style&index=0&id=ba4d8b6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba4d8b6c",
  null
  
)

export default component.exports